export default "__VITE_ASSET__BLHFPfWI__"